//页面跳转
    var loading = function() {

        var clickProductSeriesIndex = sessionStorage.getItem('clickProductSeriesIndex');

        if (clickProductSeriesIndex){

            var node = '#allProduct-productListBlock-' + clickProductSeriesIndex;

            if ($(node).length > 0){
                //head
                var offset = $("header").height();

                //message
                if ($(".message").length) {
                    offset += $(".message").height();
                }

                //body中的div
                $('main > div').each(function() {
                    if ($(this).find(node).length > 0) {
                        return false; // 找到后退出循环
                    } else {
                        offset = offset + $(this).height()
                    }
                });

                window.scrollTo({
                    top: offset,
                    behavior: 'smooth'
                });
            }

            sessionStorage.removeItem('clickProductSeriesIndex');
        }
    };

    loading();